import { Image as ChakraImage, Box, LayoutProps } from '@chakra-ui/react'
import { useState } from 'react'

import Lightbox, { LightboxProps } from 'components/Lightbox'

import ImageCaption from './ImageCaption'
import Overlay from './Overlay'

export interface ImageProps {
  h?: LayoutProps['h']
  w?: LayoutProps['w']
  url: string
  alt?: string
  caption?: string
  hideOverlay?: boolean
  lightboxProps?: Pick<LightboxProps, 'images' | 'initialSelected'>
}

const Image: React.FC<ImageProps> = ({
  h = '96',
  w = '100%',
  url,
  alt,
  caption,
  lightboxProps,
  hideOverlay = false,
  children: overlayChildren,
}) => {
  const [isLightboxOpen, setIsLightboxOpen] = useState(false)

  return (
    <Box mx="center">
      <Box position="relative" bg="background">
        {!hideOverlay ? (
          <Overlay onClickLightbox={() => setIsLightboxOpen(true)}>
            {overlayChildren}
          </Overlay>
        ) : null}

        <ChakraImage
          h={h}
          w={w}
          src={url}
          alt={alt ?? caption}
          objectFit="cover"
          fallback={<Box w="full" h={h} />}
        />

        {isLightboxOpen ? (
          <Lightbox
            onClose={() => setIsLightboxOpen(false)}
            images={[{ url, alt, caption }]}
            {...lightboxProps} // n.b. if this exists, will override `images` above
          />
        ) : null}
      </Box>

      {caption ? (
        <ImageCaption
          aria-hidden={alt == null} // n.b. caption is provided as alt text above
          caption={caption}
        />
      ) : null}
    </Box>
  )
}

export default Image
